<template>
  <div class="">
    <img :src="png1">
  </div>
</template>
<script>
const png1 = require('./info.png')
export default {
  name: 'WeInfoView',
  data() {
    return { png1 }
  }
}
</script>
